<template>
  <div class="app-tabs__tab">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'AppTabsTab',
  props: {
    title: {
      type: String,
      default: 'Tab',
    },
  },
}
</script>

<style></style>
